// Navbar.jsx

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import ThemeSwitcher from "./ThemeSwitcher";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { to: "/", label: "Acasă" },
    { to: "/despre", label: "Despre mine" },
    { to: "/servicii", label: "Servicii" },
    { to: "/membership", label: "Membership" },
    { to: "/resurse", label: "Resurse gratuite" },
    { to: "/marturii", label: "Mărturii" },
  ];

  return (
    <header className="bg-base text-body shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <Logo />

        {/* Desktop nav */}
        <nav className="hidden md:flex gap-6 text-sm items-center ml-auto">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`hover:underline transition duration-200 ${
                location.pathname === link.to ? "font-semibold underline" : ""
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="ml-6">
            <ThemeSwitcher />
          </div>
        </nav>

        {/* Mobile menu button */}
        <button
          className="md:hidden"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Deschide meniul"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile nav */}
      {isOpen && (
        <nav className="md:hidden px-4 pb-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setIsOpen(false)}
              className={`hover:underline transition duration-200 ${
                location.pathname === link.to ? "font-semibold underline" : ""
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="mt-3">
            <ThemeSwitcher />
          </div>
        </nav>
      )}
    </header>
  );
}
